import axiosInstance from "../axios";
import { baseURLGame, SEND_SCORE, CHECK_CHANCE } from "../../utils/endPoints";
import { gameAction } from "./slice";
import { sendScoreType } from "../../types/game";
import { configAction } from "../config/slice";
import { GameStep } from "../../types/config";
export const sendScore = function (token: string, category: string) {
  return async (dispatch: Function) => {
    dispatch(gameAction.setLoadingScore(true));
    try {
      const config = {
        url: `${baseURLGame}${SEND_SCORE}`,
        method: "POST",
        timout: 0,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          category: category,
        },
      };
      const response = await axiosInstance(config);
      if (response.data.status_code === 403) {
        dispatch(configAction.setGameStep(GameStep.CHANCE));
      }
      dispatch(gameAction.setSendScore(response.data));
      const scoreData = response.data as sendScoreType;
      dispatch(gameAction.setChance(scoreData.data.user.chance));
      return scoreData;
    } catch (error) {}
  };
};
export const checkChance = function (token: string) {
  return async (dispatch: Function) => {
    dispatch(gameAction.setLoadingCheck(true));
    try {
      const config = {
        url: `${baseURLGame}${CHECK_CHANCE}`,
        method: "GET",
        timout: 0,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axiosInstance(config);
      dispatch(gameAction.setCheckChance(response.data));
    } catch (error) {}
  };
};
